<template>
    
</template>

<script>
    import EventBus from "../main";
    import WaterPrint from "../components/WaterPrint";
    export default {
        name: "tskb",
        data() {
            return {
                
            }
        },
        components: {
            EventBus,
            WaterPrint
        },
        created() {
            EventBus.$emit('water-print-status')
            
        },
        mounted() {
            $('#home-container').hide();
        }
    }
</script>